const initialState = {
  orderNumber: '',
  locationCode: '',
  address:null,
  nodes:null,
  lat:null,
  lgt:null,
  serviceAddress:'',
  customerLocation: {
    address: {},
    lat: null,
    lng: null,
  },
  nodes: [],
  coords: []
};

function compassAppReducer(state = initialState, action) {
  switch (action.type) {
    case 'COVERAGE_DETAILS': {
      return {...state,address:action.address,nodes:action.nodes,lat:action.lat,lgt:action.lgt,coords:action.coords,serviceAddress:action.serviceAddress};
                             }
    default:
      return state;
                       }

}

export default compassAppReducer;